import { TypeMe } from "../types";

export const Me: TypeMe = {
  profile: {
    author: "Pablo Vega",
    authorMYS: "PABLO VEGA",
    name: "Pablo Cesar Vega Valverde",
    acronymName: "PCVV",
    acronymDescrip: "PCVV DEV",
    firstName: "Pablo Cesar",
    lastName: "Vega Valverde",
    description: "Desarrollador Backend - Frontend",
    mainDescription: "DESARROLLADOR",
    subDescription: "BACKEND - FRONTEND",
    emailCurrent: "pvegav@autonoma.edu.pe",
    emailUniversity: "pvegav@autonoma.edu.pe",
    emailAAT: "pvegav@aat.com.pe",
    phoneCurrent: "+51 980251512",
    whatsapp: "51980251512",
    yearsExperience: "1",
    proyects: "2"
  },
  who: {
    main: "Compañero de trabajo confliable, adaptable a cualquier tipo de proyecto, con ganas de aprender y mejorar cada día."
  }
};
